export const roomData = [
  {
    _id: '65aa8018d5f1f63a86d83ae8',
    roomType: 'deluxe',
    price: 2000,
    name: 'Single Bed',
    capacity: 1,
    description: 'Delux Room',
  },
  {
    _id: '65aa8029d5f1f63a86d83aea',
    roomType: 'deluxe',
    price: 3000,
    name: 'Double Bed',
    capacity: 3,
    description: '',
  },
  {
    _id: '65aa804bd5f1f63a86d83aee',
    roomType: 'super deluxe',
    price: 3000,
    name: 'Single Bed',
    capacity: 1,
    description: '',
    date: '2024-01-19T13:59:39.431Z',
  },
  {
    _id: '65aa805bd5f1f63a86d83af0',
    roomType: 'super deluxe',
    price: 4000,
    name: 'Double Bed',
    capacity: 3,
    description: 'Super Deluxe Room',
  },
  {
    _id: '65aa8069d5f1f63a86d83af2',
    roomType: 'royal suite',
    price: 5000,
    name: 'Single Bed',
    capacity: 1,
    description: '',
  },
  {
    _id: '65aa8077d5f1f63a86d83af4',
    roomType: 'royal suite',
    price: 6000,
    name: 'Double Bed',
    capacity: 3,
    description: '',
  },
];
